import React from 'react';

import '../YearToDateTableV2.scss';

import {Dollar} from 'components/shared/Text/Text';
import { CURRENT_YEAR } from 'services/Dates';
import AccountInfo from './AccountInfo';
import { ytdTableColumns } from 'components/shared/Text/ColumnHeaders';
import { accountsTotals } from "state/taxes/TaxSelectors";

export const renderAccountRow = (agreement, ytdTaxData, displayYear, isRetirementAdvisoryServiceClient, isCWV, uberId) => {
    const cellRecord = (propertyName) => ({
        record: (
            <div className={'dollar-cell-v2'}>
            <Dollar> {displayYear === CURRENT_YEAR.toString() ? ytdTaxData[`currentYear${propertyName}`] : ytdTaxData[`priorYear${propertyName}`]} </Dollar>
            </div>
        ),
        variant: 'text'
    });

    return {
        rowArray: [
            {
                record: <AccountInfo agreement={agreement} isRetirementAdvisoryServiceClient={isRetirementAdvisoryServiceClient} isCWV={isCWV} uberId={uberId}/>,
                variant: 'text'
            },
            ...ytdTableColumns.map(column => cellRecord(column))
        ]};
};

export const generateRows = (className, name, isAccountType, accountType = null, ytdTaxInformation = null, displayYear = null) => {
    let rows;
    if (isAccountType) {
        const totals = accountsTotals(accountType, ytdTaxInformation, displayYear);
        rows = totals.map(column => ({
            record: <div className="dollar-cell-v2"> <Dollar>{column.total}</Dollar></div>,
            variant: 'text'
        }));
    } else {
        rows = ytdTableColumns.map(column => ({
            record: <div className={`dollar-cell-v2 ${column}`}></div>,
            variant: 'text'
        }));
    }

    return {
        className,
        rowArray: [
            { record: <p className={"blocked_data"}>{name}</p>, variant: 'text' },
            ...rows
        ]
    };
}
